import * as React from "react"

function SostenibilityEn(props) {
	return (
		<svg
			width="663" height="597"
			id="sostenibilidad_en"
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
			x="0px"
			y="0px"
			viewBox="0 0 682.45 612.32"
			xmlSpace="preserve"
			{...props}
		>
			<style>
				{
					".st88{fill:#FFFFFF}.st38,.st48{fill:#055387}.st48{fill-rule:evenodd;clip-rule:evenodd}.st78{fill:#62368c;font-family:'Amble-Bold';}.st89{fill:#1b8e40}.st109{fill:#5f2364}.st118{fill:#df5e11}.st148{opacity:.75}.st188{fill:#fff}.st198{fill:#8eb72e}.st228{fill:#fbba09}.st248{fill:none;stroke:#9e9d9c;stroke-width:.5;stroke-miterlimit:10;stroke-dasharray:5,5}.st268{fill:#613b89}.st278{fill:#8bbb40}.st288{fill:#105583}.st298{fill:none;stroke:#9e9d9c;stroke-width:1.0098;stroke-miterlimit:10}.st308{fill:#9d9d9c;font-family:'Amble-Light';}.st31{font-family:&apos;Amble-Light&apos;}.st32{font-size:8.6799px}"
				}
			</style>
			<path
				id="SVGID_x5F_1_x5F_"
				className="st88"
				d="M78.87 222.47s25.7-86.64 139.06-146.21"
			/>
			<text>
				<textPath xlinkHref="#SVGID_x5F_1_x5F_" startOffset="17.267%">
					<tspan className="st78" fontFamily="Amble-Bold" fontSize="13px">
						{"Develop and take care of our"}
					</tspan>
				</textPath>
			</text>
			<path
				id="SVGID_x5F_2_x5F_"
				className="st88"
				d="M245.16 597.66S135.21 562.38 77.77 441.87"
			/>
			<text>
				<textPath xlinkHref="#SVGID_x5F_2_x5F_" startOffset="17.267%">
					<tspan className="st278" fontFamily="Amble-Bold" fontSize="13px">
						{"Close the cycle of our products "}
					</tspan>
				</textPath>
			</text>
			<path
				id="SVGID_x5F_3_x5F_"
				className="st88"
				d="M616.51 389.22S595.81 515.92 474.53 580"
			/>
			<text>
				<textPath xlinkHref="#SVGID_x5F_3_x5F_" startOffset="17.267%">
					<tspan className="st288" fontFamily="Amble-Bold" fontSize="13px">
						{"Strengthen our business actions "}
					</tspan>
				</textPath>
			</text>
			<path
				id="SVGID_x5F_4_x5F_"
				className="st88"
				d="M106.36 217.96s14.81-60.77 105.04-114.94"
			/>
			<text>
				<textPath xlinkHref="#SVGID_x5F_4_x5F_" startOffset="0.146%">
					<tspan className="st78" fontFamily="Amble-Bold" fontSize="13px">
						{"people and communities"}
					</tspan>
				</textPath>
			</text>
			<circle cx={641.64} cy={334.51} r={36} fill="#d2ebfc" fillOpacity={0.4} />
			<defs>
				<path id="SVGID_5_" d="M615.61 311.15H668.61V359.15H615.61z" />
			</defs>
			<clipPath id="SVGID_6_">
				<use xlinkHref="#SVGID_5_" overflow="visible" />
			</clipPath>
			<g clipPath="url(#SVGID_6_)">
				<path
					className="st38"
					d="M620.06 348.12c1.1.18 2.37-.06 2.93-.29.19.33.48.9-.22 1.27-.48.26-1.22.4-2.55.4-2.71 0-4.58-1.25-4.6-4.3-.02-3.11 1.89-4.23 4.6-4.23 1.06 0 1.78.1 2.38.33.7.26.65.93.39 1.35-.56-.24-1.84-.47-2.93-.29-1.62.26-2.14 1.18-2.14 2.72 0 1.65.52 2.78 2.14 3.04z"
				/>
				<path
					className="st48"
					d="M627.56 348.43c.89 0 1.2-.5 1.2-.9v-1.12s-1.04.12-1.75.28c-.64.14-.84.34-.84.83 0 .58.38.91 1.39.91zm.16-5.37c1.69 0 3.01.55 3.01 2.07v2.46c0 1.09-1.07 1.92-3.09 1.92-2.04 0-3.36-.64-3.36-2.09 0-1.27.96-1.58 3.58-1.96l.9-.13c0-.79-.1-1.14-1.42-1.14-1.17 0-2.37.38-2.37.38-.2-.42-.14-.94.17-1.11.34-.19 1.06-.4 2.58-.4zM636.03 343.23c.36.13.52.5.38 1.04 0 0-.47-.06-1.01-.06-.97 0-1.19.28-1.19 1.03v2.93c0 .7-.51 1.26-1.33 1.26-.5 0-.68-.06-.68-.06v-4.22c0-1.42.9-2.08 2.37-2.08.76-.01 1.17.05 1.46.16zM644.22 343.06c.32 0 .54.13.54.13l-2.19 5.24c-.26.61-.75 1-1.45 1-.83 0-1.37-.37-1.63-1l-2.13-5.13s.39-.24 1.05-.24c.77 0 1.2.37 1.38.82l1.53 4.04 1.48-3.9c.27-.68.69-.96 1.42-.96zM651.46 351.64c-.36-.13-.51-.5-.38-1.04 0 0 .47.06 1.01.06.97 0 1.19-.29 1.19-1.04v-5.31c0-.7.51-1.26 1.33-1.26.5 0 .68.06.68.06v6.61c0 1.42-.9 2.08-2.37 2.08-.77 0-1.18-.05-1.46-.16zM659.79 348.43c1.01 0 1.26-.5 1.27-.9v-1.12s-1.14.12-1.85.28c-.64.14-.84.34-.84.83-.01.61.41.91 1.42.91zm.13-5.37c1.69 0 3.01.55 3.01 2.07v2.49c0 1.08-1.07 1.88-3.08 1.88-2.04 0-3.32-.64-3.32-2.09 0-1.27.91-1.62 3.54-1.96l1.01-.13c-.02-.79-.21-1.14-1.52-1.14-1.17 0-2.37.38-2.37.38-.2-.42-.14-.94.17-1.11.31-.18 1.03-.39 2.56-.39zM668.19 349.27c-.29.1-.69.16-1.45.16-1.48 0-2.37-.66-2.37-2.08v-6.61s.17-.06.68-.06c.82 0 1.33.56 1.33 1.26v5.31c0 .75.21 1.03 1.19 1.03.54 0 1.01-.06 1.01-.06.12.55-.04.92-.39 1.05zM648.51 348.43c.89 0 1.2-.5 1.2-.9v-1.12s-1.04.12-1.75.28c-.64.14-.84.34-.84.83 0 .58.37.91 1.39.91zm.16-5.37c1.69 0 3.01.55 3.01 2.07v2.42c0 1.09-1.07 1.96-3.08 1.96-2.04 0-3.36-.64-3.36-2.09 0-1.27.96-1.58 3.58-1.96l.9-.13c0-.79-.1-1.14-1.42-1.14-1.17 0-2.37.38-2.37.38-.2-.42-.13-.94.17-1.11.33-.19 1.05-.4 2.57-.4z"
				/>
				<path d="M642.26 323.88h-3.36v3.25h3.36v-3.25z" fill="#056530" />
				<path
					d="M631.71 332.46c0 .93.77 1.69 1.72 1.69h5.47v-7.03h-7.2v5.34z"
					fill="#02b6e6"
				/>
				<path
					className="st78"
					d="M645.55 313.6v7.02h7.16v-5.33c0-.93-.77-1.69-1.72-1.69h-5.44z"
				/>
				<path className="st89" d="M642.26 327.12h-3.36v7.03h3.36v-7.03z" />
				<path
					d="M629.17 327.12h2.54v-3.25h7.2v-3.27h3.36v-7.02h3.29v-2.45H630.9c-.95 0-1.72.76-1.72 1.69l-.01 14.3z"
					fill="#f07e07"
				/>
				<path
					className="st109"
					d="M645.55 313.6h-3.29v7.02h3.29v-7.02zM652.71 320.61h-7.16v3.27h7.16v-3.27z"
				/>
				<path className="st118" d="M642.26 320.61h-3.36v3.27h3.36v-3.27z" />
				<path d="M645.55 320.61h-3.29v3.27h3.29v-3.27z" fill="#3c235a" />
				<path className="st118" d="M645.55 323.88h-3.29v3.25h3.29v-3.25z" />
				<path className="st89" d="M638.91 323.88h-7.2v3.25h7.2v-3.25z" />
				<path
					d="M653.33 336.47c.95 0 1.72-.75 1.72-1.69v-14.17h-2.35v3.27h-7.16v3.24h-3.29v7.03h-3.36v2.3l14.44.02z"
					fill="#8bbe29"
				/>
				<g className="st148">
					<g className="st148">
						<path
							d="M650.59 326.8c-1.36-1.33-3.3-1.37-4.7 0l-3.62 3.58-6.7-6.51 6.69-6.53 3.79 3.75c1.3 1.28 3.38.92 4.38 0 1.1-1.01 1.42-1.38 1.42-1.38l-5.83-5.71a5.453 5.453 0 00-3.81-1.53c-1.66 0-2.96.71-3.8 1.53l-6.3 6.17c-.66.65-1.57 1.92-1.57 3.7 0 1.88 1.01 3.16 1.57 3.7l6.33 6.2c.85.83 2.12 1.53 3.8 1.53 1.38 0 2.76-.51 3.81-1.53l5.82-5.71-1.28-1.26z"
							opacity={0.75}
							fill="#fff"
							className=""
						/>
					</g>
				</g>
				<path
					className="st38"
					d="M627.29 354.94h2.63v.61h-1.95v.97h1.66v.61h-1.66v.97h1.99v.61h-2.67v-3.77zM632.71 357.68l.1.28.1-.28.97-2.74h1.02v3.78h-.68v-2.67l.02-.38-1.09 3.05h-.66l-1.09-3.05.02.38v2.67h-.68v-3.78h1.02l.95 2.74zM636.46 357.45v1.26h-.68v-3.78h1.6c.2 0 .38.03.54.08s.31.13.43.23.22.23.28.39c.07.16.1.34.1.56 0 .21-.03.4-.1.56-.07.16-.17.29-.29.39-.12.1-.26.18-.43.23-.17.05-.35.08-.54.08h-.91zm0-1.9v1.29h.89c.47 0 .7-.22.7-.65 0-.21-.06-.37-.18-.47-.12-.11-.29-.16-.51-.16h-.9zM642.28 358.71h-.73l-.3-.88h-1.59l-.3.88h-.73l1.38-3.78h.89l1.38 3.78zm-2.42-1.47h1.18l-.59-1.72-.59 1.72zM642.36 356.83c0-.28.05-.55.15-.79.1-.24.24-.45.42-.62.18-.17.39-.31.63-.4.24-.1.51-.15.79-.15s.55.05.79.15c.24.1.46.23.63.4.18.17.32.38.42.62.1.24.15.5.15.78 0 .29-.05.56-.15.8-.1.24-.24.44-.42.62l.44.53-.46.38-.47-.57c-.27.13-.58.19-.92.19-.28 0-.55-.05-.79-.14-.24-.09-.45-.22-.63-.4-.18-.17-.32-.38-.42-.61-.11-.23-.16-.5-.16-.79zm.68 0c0 .19.03.37.09.54.06.16.15.3.26.42.11.12.25.21.41.27.16.07.34.1.54.1.18 0 .34-.03.5-.09l-.46-.56.47-.37.49.59c.1-.11.17-.25.23-.4.05-.16.08-.33.08-.51 0-.19-.03-.37-.1-.54a1.194 1.194 0 00-.67-.7c-.16-.07-.34-.1-.54-.1s-.38.03-.54.1c-.16.07-.3.16-.41.28-.11.12-.2.26-.26.43-.06.16-.09.35-.09.54zM649.43 354.94h.68v2.36c0 .22-.03.42-.09.6s-.16.34-.28.47c-.13.13-.29.23-.48.3-.19.07-.42.11-.69.11-.27 0-.5-.04-.69-.11-.19-.07-.35-.17-.48-.3-.13-.13-.22-.28-.28-.47a1.89 1.89 0 01-.09-.6v-2.36h.68v2.37c0 .3.08.52.23.65.15.14.36.2.63.2.28 0 .49-.07.64-.21.15-.14.22-.36.22-.65v-2.36zM651 354.94h2.63v.61h-1.95v.97h1.66v.61h-1.66v.97h1.99v.61H651v-3.77zM656.37 355.77c-.1-.1-.2-.17-.31-.22a.986.986 0 00-.4-.07c-.19 0-.33.05-.43.14-.1.09-.15.21-.15.34a.437.437 0 00.13.33c.05.04.11.09.2.13.08.04.19.08.32.13.22.07.41.15.57.23.16.07.28.16.38.25.1.09.17.19.21.3s.07.24.07.37c0 .14-.02.27-.06.4-.04.13-.11.25-.21.34-.1.1-.24.18-.41.25-.17.06-.39.09-.66.09-.3 0-.55-.05-.77-.14-.22-.09-.4-.22-.56-.37l.41-.5c.12.14.27.24.42.3.16.07.33.1.51.1.24 0 .41-.04.51-.13.1-.08.14-.2.14-.35 0-.07-.01-.13-.03-.18a.396.396 0 00-.12-.15c-.06-.04-.13-.09-.22-.13-.1-.04-.22-.09-.37-.14-.38-.12-.66-.27-.85-.45-.18-.18-.27-.41-.27-.7 0-.15.03-.3.08-.43a.94.94 0 01.25-.34c.11-.09.24-.17.4-.23.16-.05.34-.08.54-.08.25 0 .46.04.64.12.18.08.33.18.46.3l-.42.49z"
				/>
			</g>
			<path
				d="M41.68 363.43c19.33 0 35-15.67 35-35s-15.67-35-35-35-35 15.67-35 35 15.67 35 35 35z"
				opacity={0.23}
				fill="#8eb72e"
			/>
			<path
				className="st38"
				d="M11.34 334.49c-.44 0-.88-.22-1.21-.55-.55-.66-.55-1.76.22-2.31l3.97-3.41c.55-.44 1.32-.55 1.98-.11l4.63 2.86c.77.44.99 1.54.55 2.31-.44.77-1.54.99-2.31.55l-3.52-2.2-2.97 2.53c-.57.22-.9.33-1.34.33z"
			/>
			<path
				className="st38"
				d="M39.87 359.17s-.11 0 0 0c-7.38-.22-14.1-3.3-19.17-8.7-4.96-5.4-7.6-12.34-7.27-19.61 0-.88.77-1.65 1.76-1.54.88 0 1.65.77 1.54 1.76-.22 6.39 2.09 12.56 6.5 17.29 4.41 4.74 10.35 7.38 16.74 7.6.88 0 1.65.77 1.54 1.76.01.67-.76 1.44-1.64 1.44zM68.07 333.72c-.44 0-.77-.11-1.1-.44L63 329.65c-.66-.66-.66-1.65-.11-2.31.66-.66 1.65-.66 2.31-.11l3.08 2.86 3.41-1.98c.77-.44 1.76-.22 2.2.66.44.77.22 1.76-.66 2.2l-4.52 2.64c-.09.11-.31.11-.64.11z"
			/>
			<path
				className="st38"
				d="M68.62 332.4h-.33c-.88-.22-1.43-1.1-1.21-1.98 1.43-6.28.22-12.78-3.19-18.18s-8.81-9.14-15.09-10.57c-.88-.22-1.43-1.1-1.21-1.98s1.1-1.43 1.98-1.21c7.16 1.54 13.22 5.84 17.18 12.01s5.18 13.55 3.64 20.6c-.34.87-1 1.31-1.77 1.31z"
			/>
			<defs>
				<path id="SVGID_7_" d="M24.44 305.42H55.18V351.40000000000003H24.44z" />
			</defs>
			<clipPath id="SVGID_8_">
				<use xlinkHref="#SVGID_7_" overflow="visible" />
			</clipPath>
			<g clipPath="url(#SVGID_8_)">
				<path className="st188" d="M47.21 348.23h-14.8v1.18h14.8v-1.18z" />
				<path
					className="st198"
					d="M30.82 336.09c.04 0 .08-.01.12-.01h18.14c.07 0 .13.01.19.02v-.06l1.17-16.41-21.14-.2 1.52 16.66z"
				/>
				<path
					className="st188"
					d="M49.41 309.04c-2.15-.33-5.38-.62-9.6-.62s-7.46.28-9.61.62c2.15.33 5.38.62 9.61.62 4.22 0 7.46-.28 9.6-.62zM31.9 344.42s.06.8.46.8h15.1c.1 0 .03-.01.12.01-.02 0 .1-.01.13-.5l.46-5.65H31.9v5.34zM27.62 311.59l.45 4.85c.07-.01.15-.02.23-.02h.01l23.17.22c.14-.17.29-.43.29-.73l.28-4.34c-2.17.61-5.88 1.09-12.24 1.09-6.3 0-10.01-.46-12.19-1.07z"
				/>
				<path
					className="st38"
					d="M55.11 309.04c0-.9 0-3.62-15.3-3.62s-15.3 2.72-15.3 3.62v.16a1.5 1.5 0 00-.06.6l.7 7.57c.05.8.44 1.6 1.14 2.07l1.6 17.54c.08.79.42 1.61 1.01 2.13v5.36c.03 1.01.48 2.35 1.51 3.12v2.81c0 .55.45 1 1 1h16.8c.55 0 1-.45 1-1v-2.69c.12-.07.23-.13.34-.23.48-.41 1.07-1.19 1.16-2.53l.5-6.09c.47-.52 1.05-1.42 1.06-2.65l1.24-17.33c.55-.55 1.27-1.52 1.26-2.86l.4-6.25c.01-.19-.01-.37-.07-.54.01-.08.01-.14.01-.19zm-15.3-.62c4.22 0 7.46.28 9.6.62-2.15.33-5.38.62-9.6.62s-7.46-.28-9.61-.62c2.15-.33 5.39-.62 9.61-.62zm7.4 40.98h-14.8v-1.18h14.8v1.18zm.5-4.67c-.03.49-.15.49-.13.5-.1-.02-.03-.01-.12-.01h-15.1c-.4 0-.46-.8-.46-.8v-5.34h16.28l-.47 5.65zm1.56-8.69v.06c-.06-.01-.13-.02-.19-.02H30.94c-.04 0-.08.01-.12.01l-1.52-16.66 21.15.2-1.18 16.41zm2.5-20.13c0 .3-.15.55-.29.73l-23.16-.22h-.01c-.08 0-.15.01-.23.02l-.45-4.85c2.18.61 5.88 1.07 12.18 1.07 6.36 0 10.07-.47 12.24-1.08l-.28 4.33z"
				/>
			</g>
			<defs>
				<path id="SVGID_9_" d="M309.4 6.4H378.4V72.4H309.4z" />
			</defs>
			<clipPath id="SVGID_10_">
				<use xlinkHref="#SVGID_9_" overflow="visible" />
			</clipPath>
			<g clipPath="url(#SVGID_10_)">
				<path
					d="M342.52 72.4c18.29 0 33.12-14.77 33.12-33s-14.83-33-33.12-33-33.12 14.77-33.12 33 14.83 33 33.12 33z"
					opacity={0.23}
					fill="#62368c"
				/>
				<path className="st188" d="M371.87 31.39s.54 8.02 4.76 8.9h-9.52" />
				<path
					className="st38"
					d="M376.63 41.87h-9.52c-.88 0-1.59-.71-1.59-1.59 0-.88.71-1.59 1.59-1.59h5.21c-1.68-2.84-1.99-6.59-2.03-7.21-.06-.87.6-1.63 1.48-1.69.92-.06 1.64.6 1.69 1.47.15 2.22 1.21 6.98 3.5 7.46.8.17 1.34.91 1.26 1.72-.09.82-.77 1.43-1.59 1.43z"
				/>
				<path className="st188" d="M352.49 32s-.59 6.64-5.02 8.29l10.63-.89" />
				<path
					className="st38"
					d="M347.48 41.87a1.583 1.583 0 01-.55-3.07c3.43-1.27 3.98-6.89 3.99-6.95.08-.87.87-1.52 1.73-1.44.87.08 1.52.84 1.44 1.72-.02.2-.33 3.42-2.03 6.18l5.92-.49c.89-.08 1.65.58 1.72 1.45.07.87-.58 1.64-1.45 1.71l-10.63.89h-.14z"
				/>
				<path
					className="st228"
					d="M336.93 45.2l-4.89-1.63c-.34 2.37-2.5 4.21-5.15 4.21-2.6 0-4.75-1.78-5.14-4.1l-5.22 1.54c-4.37 1.31-3.93 5.86-3.91 6.05.01.06.01.11.01.17v10.93h27.68V51.44c0-.05 0-.1.01-.15.02-.19.37-4.81-3.39-6.09z"
				/>
				<path
					className="st188"
					d="M324.86 42.93c0 .92.91 1.67 2.04 1.67 1.12 0 2.03-.75 2.03-1.67v-1.58c-.56.1-1.09.15-1.54.16-.91 0-1.75-.09-2.53-.25v1.67zM338.8 25.41c0-.19-.16-.35-.35-.35h-22.48c-.19 0-.35.16-.35.35s.16.35.35.35h22.48c.19 0 .35-.16.35-.35z"
				/>
				<path
					className="st198"
					d="M333.62 15.82v.1c0 .88-.71 1.59-1.59 1.59s-1.59-.71-1.59-1.59v-1.83c-.54-.18-1.05-.31-1.49-.39v4.57c0 .88-.71 1.59-1.59 1.59-.88 0-1.59-.71-1.59-1.59v-4.62c-.53.08-1.03.19-1.49.32v1.94c0 .88-.71 1.59-1.59 1.59-.88 0-1.59-.71-1.59-1.59v-.31c-2.58 2.04-3.28 4.99-3.47 6.29h19.15c-.37-2.93-1.65-4.83-3.16-6.07z"
				/>
				<path
					className="st188"
					d="M327.36 38.34c.24-.01 6.8-.25 7.66-6.91.06-.44.2-.85.56-1.11.37-.25.72-.36 1.15-.27-.02-.01.04-.03.1-.1.13-.15.24-.49.27-1.03h-19.56c-.02.36.03.8.18.99.06.08.2.12.41.13.77.04 1.41.64 1.49 1.41.05.28.93 6.89 7.74 6.89z"
				/>
				<path
					className="st198"
					d="M368.5 15.82v.1c0 .88-.71 1.59-1.59 1.59s-1.59-.71-1.59-1.59v-1.83c-.54-.18-1.05-.31-1.49-.39v4.57c0 .88-.71 1.59-1.59 1.59-.88 0-1.59-.71-1.59-1.59v-4.62c-.53.08-1.03.19-1.49.33v1.94c0 .88-.71 1.59-1.59 1.59s-1.59-.71-1.59-1.59v-.3c-2.55 2.04-3.27 4.97-3.47 6.27h19.14c-.36-2.93-1.64-4.83-3.15-6.07z"
				/>
				<path
					className="st188"
					d="M359.73 42.93c0 .92.91 1.67 2.04 1.67 1.12 0 2.03-.75 2.03-1.67v-1.58c-.56.1-1.09.15-1.54.16-.91 0-1.75-.09-2.53-.25v1.67z"
				/>
				<path
					className="st228"
					d="M371.81 45.2l-4.89-1.63c-.34 2.37-2.5 4.21-5.15 4.21-2.6 0-4.75-1.78-5.14-4.1l-5.22 1.54c-4.37 1.31-3.93 5.86-3.91 6.05.01.06.01.11.01.17v10.93h27.68V51.44c0-.05 0-.1.01-.15.01-.19.37-4.81-3.39-6.09z"
				/>
				<path
					className="st188"
					d="M362.23 38.34c.25-.01 6.8-.25 7.66-6.91.06-.44.2-.86.56-1.11.36-.25.72-.36 1.15-.27-.02-.01.04-.03.1-.09.13-.15.24-.49.27-1.03h-19.56c-.02.36.03.8.18.99.06.08.2.12.41.13.77.04 1.41.64 1.49 1.41.05.27.93 6.88 7.74 6.88zM373.68 25.41c0-.19-.16-.35-.35-.35h-22.48c-.19 0-.35.16-.35.35s.16.35.35.35h22.48c.19 0 .35-.16.35-.35z"
				/>
				<path
					className="st38"
					d="M337.95 42.2l-5.72-1.91c2.49-1.21 4.9-3.46 5.75-7.34.35-.15.72-.38 1.07-.72.86-.86 1.26-2.15 1.22-3.82 1.02-.62 1.71-1.73 1.71-3 0-1.38-.81-2.57-1.98-3.15-.81-11.58-12.5-11.93-12.71-11.93-9.71.39-12.69 7.94-12.92 11.96a3.498 3.498 0 00-1.93 3.12c0 1.37.79 2.54 1.94 3.12-.06.75-.05 2.22.84 3.34.29.37.75.8 1.44 1.07.54 2.31 2.03 5.33 5.01 7.1v.36l-6.05 1.78c-5.44 1.63-6.42 6.77-6.18 9.34v12.43c0 .88.71 1.59 1.59 1.59h30.86c.88 0 1.59-.71 1.59-1.59V51.51c.23-2.55-.65-7.66-5.53-9.31zm-16.86-26.6v.32c0 .88.71 1.59 1.59 1.59.88 0 1.59-.71 1.59-1.59v-1.94c.46-.14.96-.24 1.49-.32v4.62c0 .88.71 1.59 1.59 1.59s1.59-.71 1.59-1.59V13.7c.44.09.95.21 1.49.39v1.83c0 .88.71 1.59 1.59 1.59s1.59-.71 1.59-1.59v-.1c1.51 1.24 2.79 3.14 3.14 6.07H317.6c.2-1.3.91-4.25 3.49-6.29zm-5.12 10.16c-.19 0-.35-.16-.35-.35 0-.19.16-.35.35-.35h22.48c.19 0 .35.16.35.35s-.16.35-.35.35h-22.48zm3.66 5.7c-.09-.77-.72-1.36-1.49-1.41-.21-.01-.35-.06-.41-.13-.15-.19-.2-.63-.18-.99h19.56c-.03.54-.15.89-.27 1.03-.06.07-.12.09-.1.1-.44-.09-.79.01-1.15.27-.37.26-.51.67-.56 1.11-.86 6.66-7.42 6.9-7.66 6.91-6.82-.01-7.7-6.62-7.74-6.89zm9.3 9.9v1.58c0 .92-.91 1.67-2.03 1.67-1.12 0-2.04-.75-2.04-1.67v-1.67c.78.16 1.62.25 2.53.25.45-.01.98-.07 1.54-.16zm11.39 9.93c-.01.05-.01.1-.01.15v10.93h-27.68V51.44c0-.06 0-.11-.01-.17-.02-.19-.46-4.74 3.91-6.05l5.22-1.54c.39 2.32 2.54 4.1 5.14 4.1 2.64 0 4.81-1.84 5.15-4.21l4.89 1.63c3.76 1.28 3.41 5.9 3.39 6.09zM372.83 42.2l-5.72-1.91c2.49-1.21 4.9-3.46 5.75-7.34.35-.15.72-.38 1.07-.72.86-.86 1.26-2.15 1.22-3.82 1.02-.62 1.71-1.73 1.71-3 0-1.38-.81-2.57-1.98-3.15-.81-11.58-12.5-11.93-12.71-11.93-9.71.39-12.69 7.94-12.92 11.96a3.498 3.498 0 00-1.93 3.12c0 1.37.79 2.54 1.94 3.12-.06.75-.05 2.22.84 3.34.29.37.75.8 1.44 1.07.54 2.31 2.03 5.33 5.01 7.1v.36l-6.05 1.78c-5.44 1.63-6.42 6.77-6.18 9.34v12.43c0 .88.71 1.59 1.59 1.59h30.86c.88 0 1.59-.71 1.59-1.59V51.51c.22-2.55-.66-7.66-5.53-9.31zm-16.87-26.58v.3c0 .88.71 1.59 1.59 1.59.88 0 1.59-.71 1.59-1.59v-1.94c.46-.14.96-.25 1.49-.33v4.61c0 .88.71 1.59 1.59 1.59s1.59-.71 1.59-1.59V13.7c.44.09.95.21 1.49.39v1.83c0 .88.71 1.59 1.59 1.59s1.59-.71 1.59-1.59v-.1c1.51 1.24 2.79 3.14 3.14 6.07h-19.14c.21-1.3.94-4.23 3.48-6.27zm-5.11 10.14c-.19 0-.35-.16-.35-.35 0-.19.16-.35.35-.35h22.48c.19 0 .35.16.35.35s-.16.35-.35.35h-22.48zm3.66 5.7c-.09-.77-.72-1.36-1.49-1.41-.21-.01-.35-.06-.41-.13-.15-.19-.2-.63-.18-.99h19.56c-.03.54-.15.89-.27 1.03-.06.07-.12.09-.1.09-.44-.1-.79.01-1.15.27-.37.26-.51.67-.56 1.11-.86 6.66-7.42 6.9-7.66 6.91-6.83 0-7.71-6.61-7.74-6.88zm9.29 9.9v1.58c0 .92-.91 1.67-2.03 1.67-1.12 0-2.04-.75-2.04-1.67v-1.67c.78.16 1.62.25 2.53.25.46-.01.98-.07 1.54-.16zm11.39 9.93c-.01.05-.01.1-.01.15v10.93H347.5V51.44c0-.06 0-.11-.01-.17-.02-.19-.46-4.74 3.91-6.05l5.22-1.54c.39 2.32 2.54 4.1 5.14 4.1 2.64 0 4.81-1.84 5.15-4.21l4.89 1.63c3.77 1.28 3.41 5.9 3.39 6.09z"
				/>
			</g>
			<path
				d="M256.39 338.98H114.12"
				fill="none"
				stroke="#9e9d9c"
				strokeMiterlimit={10}
			/>
			<path
				className="st248"
				d="M344.23 160.32H205.02M507.98 181.09H344.26M549.85 239.68h-205.6M569 295.47H416.57M577.17 355.09H429.21M565.55 416.23h-178.6M531.72 480.58H161.26M344.06 520.02H199.55M344.06 445.72H139.81M291.72 409.98H125M262.87 372.58H116.96M344.23 204.36H160.36M344.23 247.64H134.96M273.72 290.53H120.53"
			/>
			<defs>
				<path id="SVGID_11_" d="M99.64 97.11H588.91V586.39H99.64z" />
			</defs>
			<clipPath id="SVGID_12_">
				<use xlinkHref="#SVGID_11_" overflow="visible" />
			</clipPath>
			<g clipPath="url(#SVGID_12_)">
				<path
					className="st268"
					d="M182.01 179.47c43.34-43.35 100.98-67.22 162.27-67.22V97.11c-65.35 0-126.78 25.45-172.99 71.65-45.68 45.68-71.06 106.26-71.63 170.77h15.15c.57-60.47 24.37-117.23 67.2-160.06z"
				/>
				<path
					className="st278"
					d="M182.01 504.02c-43.34-43.34-67.22-100.97-67.22-162.27 0-.74.02-1.47.03-2.21H99.67c-.01.74-.03 1.47-.03 2.21 0 65.35 25.45 126.78 71.65 172.99 46.21 46.21 107.64 71.65 172.99 71.65v-15.15c-61.3 0-118.93-23.87-162.27-67.22z"
				/>
				<path
					className="st288"
					d="M344.28 271.1c38.95 0 70.65 31.69 70.65 70.65 0 38.95-31.69 70.65-70.65 70.65v15.15c47.31 0 85.79-38.49 85.79-85.79s-38.49-85.79-85.79-85.79v15.13z"
				/>
				<path
					className="st268"
					d="M344.28 271.1v-15.15c-46.56 0-84.56 37.3-85.74 83.58h15.15c1.17-37.93 32.38-68.43 70.59-68.43z"
				/>
				<path
					className="st278"
					d="M344.28 427.54v-15.15c-38.95 0-70.65-31.69-70.65-70.65 0-.74.03-1.48.06-2.21h-15.15c-.02.74-.06 1.47-.06 2.21.01 47.31 38.49 85.8 85.8 85.8z"
				/>
				<path className="st298" d="M344.28 112.26v143.7M344.28 427.54v143.7" />
				<path
					className="st288"
					d="M517.27 168.76c-46.21-46.21-107.64-71.65-172.99-71.65v15.15c61.3 0 118.93 23.87 162.27 67.22 43.27 43.27 67.13 100.78 67.21 161.96h15.15c-.08-65.24-25.51-126.55-71.64-172.68z"
				/>
				<path
					className="st288"
					d="M341.84 579.42v-3.03c62.98 0 122.19-24.53 166.72-69.06s69.06-103.74 69.06-166.72h3.03c0 63.79-24.84 123.76-69.95 168.87s-105.07 69.94-168.86 69.94z"
				/>
				<path
					className="st288"
					d="M349.51 571.53v12.75l-10.45-6.38 10.45-6.37z"
				/>
			</g>
			<text transform="translate(255.69 139.038)">
				<tspan x={0} y={0} className="st308 st31 st32">
					{"- Respect for human"}
				</tspan>
				<tspan x={0} y={10.42} className="st308 st31 st32">
					{"rights"}
				</tspan>
			</text>
			<text transform="translate(353.717 149.873)" className="st308 st31 st32">
				{"- Profitable growth"}
			</text>
			<text transform="translate(353.717 204.256)">
				<tspan x={0} y={0} className="st308 st31 st32">
					{"- Corporate governance,"}
				</tspan>
				<tspan x={0} y={10.42} className="st308 st31 st32">
					{"ethics and transparency"}
				</tspan>
			</text>
			<text transform="translate(414.877 267.755)" className="st308 st31 st32">
				{"- Risk management"}
			</text>
			<text transform="translate(441.896 326.29)" className="st308 st31 st32">
				{"- Connectivity with client"}
			</text>
			<text transform="translate(194.924 184.655)" className="st308 st31 st32">
				{"- Quality of life of our employees"}
			</text>
			<text transform="translate(165.477 223.123)">
				<tspan x={0} y={0} className="st308 st31 st32">
					{"- Management of the culture"}
				</tspan>
				<tspan x={0} y={10.42} className="st308 st31 st32">
					{"&quot;Carvajal does things well&quot;"}
				</tspan>
			</text>
			<text transform="translate(143.35 272.485)" className="st308 st31 st32">
				{"- Promote sustainable cities"}
			</text>
			<text transform="translate(130.896 311.293)">
				<tspan x={0} y={0} className="st308 st31 st32">
					{"- Develop, promote and"}
				</tspan>
				<tspan x={0} y={10.42} className="st308 st31 st32">
					{"retain our talent"}
				</tspan>
			</text>
			<text transform="translate(123.896 359.146)" className="st308 st31 st32">
				{"- Transfer cycle closure models"}
			</text>
			<text transform="translate(134.825 388.438)">
				<tspan x={0} y={0} className="st308 st31 st32">
					{"- Articulation of waste"}
				</tspan>
				<tspan x={0} y={10.42} className="st308 st31 st32">
					{"management platforms"}
				</tspan>
			</text>
			<text transform="translate(146.927 428.465)" className="st308 st31 st32">
				{"- Sustainable entrepreneurship"}
			</text>
			<text transform="translate(167.623 465.524)" className="st308 st31 st32">
				{"- Operational efficiency"}
			</text>
			<text transform="translate(196.953 494.98)">
				<tspan x={0} y={0} className="st308 st31 st32">
					{"- Development of sustainable"}
				</tspan>
				<tspan x={0} y={10.42} className="st308 st31 st32">
					{"packaging solutions"}
				</tspan>
			</text>
			<text transform="translate(251.591 536.596)">
				<tspan x={0} y={0} className="st308 st31 st32">
					{"- Partnerships with"}
				</tspan>
				<tspan x={0} y={10.42} className="st308 st31 st32">
					{"anchor companies"}
				</tspan>
			</text>
			<text transform="translate(355.544 506.537)">
				<tspan x={0} y={0} className="st308 st31 st32">
					{"- Responsible and"}
				</tspan>
				<tspan x={0} y={10.42} className="st308 st31 st32">
					{"transparent communication"}
				</tspan>
			</text>
			<text transform="translate(367.442 450.954)" className="st308 st31 st32">
				{"- Supply chain management"}
			</text>
			<text transform="translate(433.348 381.235)">
				<tspan x={0} y={0} className="st308 st31 st32">
					{"- Sustainability"}
				</tspan>
				<tspan x={0} y={10.42} className="st308 st31 st32">
					{"management system"}
				</tspan>
			</text>
		</svg>
	)
}

export default SostenibilityEn
